export default {
      id: "243,4_cm_=_120_+_120-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#243,4_cm_=_120_+_120",
      toString: function () {
        return this.url;
      }
    }